import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Rating, RatingList, Feedback, FieldsFeedback } from '@app/_models/feedback';
import { SessionService } from './session.service';


@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(
        private http: HttpClient,
        private sessionService: SessionService,
      ) {}

  getRatings(
    dateFrom: string,
    dateTo: string
  ): Observable<Rating[]> {
    const facilityId = this.sessionService.currentFacility.id
    const url = `${environment.apiUrl}/feedback/${facilityId}/topics/?date_from=${dateFrom}&date_to=${dateTo}`;
    return this.http.get<Rating[]>(url);
  }

  getFeedback(
    dateFrom: string,
    dateTo: string
  ): Observable<RatingList[]> {
    const facilityId = this.sessionService.currentFacility.id
    const url = `${environment.apiUrl}/feedback/${facilityId}/feedback/?date_from=${dateFrom}&date_to=${dateTo}`;
    return this.http.get<RatingList[]>(url);
  }
  getFeedbackFieldsAvg(
    dateFrom: string,
    dateTo: string
  ): Observable<FieldsFeedback[]> {
    const facilityId = this.sessionService.currentFacility.id
    const url = `${environment.apiUrl}/feedback/${facilityId}/fields/?date_from=${dateFrom}&date_to=${dateTo}`;
    return this.http.get<FieldsFeedback[]>(url);
  }
  findFeedback(
    sortOrder = 'user',
    pageNumber,
    pageSize = 10,
    dateFrom: string,
    dateTo: string
    ): Observable<Feedback[]> {
      
    const facilityId = this.sessionService.currentFacility.id
    const url = `${environment.apiUrl}/feedback/${facilityId}/feedback/`;
    return this.http.get<Feedback[]>(url, {
        params: new HttpParams()
            .set('ordering', sortOrder)
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString())
            .set('date_from', dateFrom)
            .set('date_to', dateTo)
    });
  }
}
